import { createRouter, createWebHistory } from "vue-router"
import ClaimPage from "@/views/ClaimPage.vue"
import CoordManager from "@/views/CoordManager.vue"
import DiseaseAnalyzer from "@/views/DiseaseAnalyzer.vue"
import Homeboard from "@/views/Homeboard.vue"


const routes = [
  { path: "/", component: Homeboard },
  { path: "/kli", component: Homeboard, meta: { brand: "kli" } },
  { path: "/304", component: Homeboard, meta: { brand: "304" } },
  { path: "/hb", component: Homeboard, meta: { brand: "hb" } },
  { path: "/sg", component: Homeboard, meta: { brand: "sg" } },
  { path: "/cnc", component: Homeboard, meta: { brand: "cnc" } },
  { path: "/moa", component: Homeboard, meta: { brand: "moa" } },
  { path: "/sng", component: Homeboard, meta: { brand: "sng" } },
  { path: "/claim", name: "Claim", component: ClaimPage },
  { path: "/admin/coords", component: CoordManager, meta: { title: "좌표관리 | Throw 보험금청구" } },
  { path: "/disease", name: "DiseaseAnalyzer", component: DiseaseAnalyzer }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router